import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import * as kitchenService from 'service/kitchen.service';
import * as orderService from 'service/order.service';
import type { RegionOption } from 'store/metadata/metadata.selectors';
import type { PunchOrderFlowState } from 'store/punchOrderFlowNext/punchOrderFlow.types';
import type { CcpBranch } from 'types/CcpBranch';
import type { CcpKitchen } from 'types/CcpKitchen';
import type { DeliveryType } from 'types/DeliveryType';
import type { FinalDeliveryType } from 'types/FinalDeliveryType';
import type { Kitchen } from 'types/Kitchen';
import type { OrderListElement } from 'types/OrderListElement';
import type { OrderType } from 'types/OrderType';
import type { POSDetails } from 'types/POSDetails';
import type { TaxRate } from 'types/TaxRate';

export const resetSelectedKitchenAndBranch = createAction(
  'punchOrderFlowNext/resetSelectedKitchenAndBranch'
);

export const setTaxRate = createAction<TaxRate>('punchOrderFlowNext/setTaxRate');

export const getPotentialDuplicates = createAsyncThunk<
  { potentialDuplicates: OrderListElement[] },
  { pointOfSaleId: string; sourceOrderFriendlyId: string },
  { state: { punchOrderFlowNext: PunchOrderFlowState } }
>('punchOrderFlowNext/getPotentialDuplicates', ({ pointOfSaleId, sourceOrderFriendlyId }) =>
  orderService
    .getPotentialDuplicates({ pointOfSaleId, sourceOrderFriendlyId })
    .then(({ elements }) => {
      return { potentialDuplicates: elements };
    })
);

export const resetPotentialDuplicates = createAction('punchOrderFlowNext/resetPotentialDuplicates');

export const resolveSelectedKitchen = createAsyncThunk(
  'punchOrderFlowNext/resolveSelectedKitchen',
  kitchenService.getCCPKitchen
);

export const getAvailableKitchensForRegion = createAsyncThunk(
  'punchOrderFlowNext/getAvailableKitchensForRegion',
  kitchenService.getCCPKitchens
);

export const setCurrency = createAction<string | null>('punchOrderFlowNext/setCurrency');

interface UpdateOrderSourceParams {
  isSourceOrderIdRequired?: boolean;
  compositionStartTime: number | null;
  orderType: OrderType;
  selectedRegion: RegionOption | null;
  selectedPos: POSDetails | null;
  sourceOrderID: string;
  selectedBranch?: CcpBranch | null;
  selectedKitchen?: CcpKitchen | null;
  deliveryType: DeliveryType | FinalDeliveryType.NO_DELIVERY;
  resolvedKitchen: Kitchen | 'KITCHEN_NOT_AVAILABLE' | null;
}

export const updateOrderSource = createAction<UpdateOrderSourceParams>(
  'punchOrderFlowNext/updateOrderSource'
);
